import React from 'react';
import { Segment, Divider, Input, Button, List, Icon, Message, Dropdown, Menu, Label } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import * as HELPER from '../../util/helpers'

/**
 * Add target component
 */
export default class AddPanelTarget extends React.Component {

	/**
     * Constructor
     * @param {*} props 
     */
    constructor(props) {
        super(props);

        this.state = {
        }
	}	
	
	handleTargetgroupChange = (e, { value }) => {
		var textContent = e.target.textContent;
		this.setState((prevState) => ({ ...prevState, newmypreferredspecialtyen: value, newmypreferredspecialtyhu: textContent })
	)}

	/**
	 * Init
	 */
	componentDidMount() {
		this.props.clearTargetSearch();
		this.props.clearRequestUi();
		this.props.clearPanelChangeUi();

		if (this.props.targetgroups.length === 0)
		{
			this.props.fetchTargetgroups();
		}

		var license = this.props.match.params.license;
		if (license !== undefined)
		{
			this.handleTargetFiltering(license);
			document.getElementById('addTarget.name').value = license;
		}
	
		document.getElementById('addTarget.name').focus();
	}

	componentWillUnmount() {
		this.props.clearTargetSearch();
		this.props.clearRequestUi();
		this.props.clearPanelChangeUi();
	}

	/**
	 * Filter targets
	 * @param {*} e 
	 */
	handleTargetFiltering(name) {
		
		if (name.length > 2)
		{
			this.props.fetchTargetsByName(name);
		}
		else
		{
			this.props.clearTargetSearch();
		}
		this.setState({ ...this.state, newmypreferredspecialtyen: undefined, newmypreferredspecialtyhu: undefined, newsegmentation: undefined });
	}

	/**
	 * Add target to panel
	 * @param {*} visitorTerritory 
	 * @param {*} targetId 
	 */
	handlePanelChangeAddTarget(visitorTerritory, target) {

		var { newmypreferredspecialtyen, newmypreferredspecialtyhu } = this.state;
		var newsegmentation = 'NA'; // No longer user-editable

		if (newmypreferredspecialtyen !== undefined && newmypreferredspecialtyen !== '')
		{
			// Brute force guard
			if (newmypreferredspecialtyen.length > 50 || newmypreferredspecialtyhu.length > 50)
			{
				alert('Hibás szakterület, kérlek töltsd be újra az oldalt és válassz újra szakterületet.');
			}
			else
			{
				this.props.panelChangeAddTarget(visitorTerritory, target.license, newsegmentation, newmypreferredspecialtyen, newmypreferredspecialtyhu, target.city, target.postalCode, target.address, target.veevaBrick);
			}
		}
		else
		{
			alert('Az adott célponthoz válassz szakterületet az orvos alatti legördülő menüből.');
		}
	}

	render() {

		return  <Segment basic loading={ this.props.isLoadingTargetgroups || this.props.isSaving }>
                    { this.props.error === undefined ? '' : <Message error>Hiba történt. { this.props.error }</Message> }
                    { this.props.errorPanelChange === undefined ? '' : <Message error>{ this.props.errorPanelChange }</Message> }
					<h3><Icon name='plus'/> Célpont panelhez / cím panelen kívüli célponthoz adása</h3>
					<Input
						fluid
						id='addTarget.name'
						placeholder='Kit keresel?'
						onChange={ (e) => this.handleTargetFiltering(e.target.value) }
					/>
					<br/>
					{ 
						this.props.isLoadingTargets ?					
						'Keresés...'
						:
						<div>
							<span>Összes találtat: <b>{ this.props.targets.length }</b> célpont</span>
							<List divided relaxed='very' verticalAlign='middle'>
								{
									this.props.targets.length > 150 ?
									<List.Item><center style={{ 'color': '#aaa'}}>Túl sok találat, pontosítsd a nevet.</center></List.Item>
									:
									this.props.targets.map( (t, index) => {
										return <List.Item key={ index }>
													<List.Content floated='right'>
														<Button disabled={ !(this.props.isPanelOpen || HELPER.isPanelChangePeriod()) } onClick={ () => this.handlePanelChangeAddTarget(this.props.visitorTerritory, t) } icon color='green'><Icon name='plus'/> Panelhez ad</Button>
														<br/>
														<br/>
														<Link to={ '/addAddress/' + t.license }><Button icon color='green'><Icon name='plus'/> Új cím</Button></Link>
													</List.Content>
													<List.Content>
														<b>{ t.name }</b>
														<br/>
														<span className="panel-list-meta" style={{ color: '#aaa' }}>{ t.license }</span>
														<List.Description>
															{ t.city }, { t.postalCode }, { t.address }
															<table cellPadding='0' cellSpacing='8'>
																<tbody>
																	<tr>
																		<td>
																			<b>Szegmentáció</b> &nbsp;
																		</td>
																		<td>
																			<Label 
																				size='small' 
																				basic 
																				color={t.segmentation && t.segmentation !== 'NA' ? 'green' : undefined}
																			>
																				{ t.segmentation || 'NA' }
																			</Label>
																		</td>
																	</tr>
																	<tr>
																		<td>
																			<b>Szakterület</b> &nbsp;
																		</td>
																		<td>
																			<Menu compact>
																				<Dropdown onChange={ this.handleTargetgroupChange } 
																						  selection 
																						  defaultValue='' 
																						  placeholder='Válasszon szakterületet' 
																						  id='target.targetgroup' 
																						  options={ HELPER.generateSpecialtyList(t, this.props.targetgroups) } 
																						  item />
																			</Menu>
																		</td>
																	</tr>			
																</tbody>														
															</table>															
														</List.Description>
													</List.Content>
												</List.Item>
									}, this)
								}
							</List>
						</div>
					}
					<Divider/>
					<Link to='/panelChanges'><Button basic primary>Mégse</Button></Link>
					<Link to='/newTarget'><Button basic floated='right' primary icon><Icon name='user'/> Új célpont</Button></Link>
				</Segment>
	}
}